import { render } from "./CompanyDropdown.vue?vue&type=template&id=17d345b5"
import script from "./CompanyDropdown.vue?vue&type=script&lang=ts"
export * from "./CompanyDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script